import React, { useState, useEffect, useMemo } from "react";
import { FaBookmark, FaRegBookmark } from "react-icons/fa";
import { MdMoreHoriz } from "react-icons/md";
import { getCoinTickers } from "../services/api";
import Button from "./Button";

const getStatusBadge = (isActive) => (
  <span
    className={`px-2 py-1 uppercase font-semibold border-2 rounded-full ${
      isActive
        ? "border-blue-500 text-blue-500 "
        : "border-red-500 text-red-500"
    }`}
  >
    {isActive ? "active" : "inactive"}
  </span>
);

const CoinCard = ({ coin }) => {
  const { name, symbol, rank, id } = coin;
  const [coinPrice, setCoinPrice] = useState(null);
  const [isBookmarked, setIsBookmarked] = useState(false);

  const fetchCoinPrice = useMemo(
    () => async () => {
      try {
        const response = await getCoinTickers(id);
        const price = response.data.quotes?.USD?.price;
        setCoinPrice(price);
      } catch (error) {
        console.error("Error fetching coin tickers:", error);
      }
    },
    [id]
  );

  useEffect(() => {
    fetchCoinPrice();
  }, [fetchCoinPrice]);

  useEffect(() => {
    // Check if the coin is bookmarked on component mount
    const isCoinBookmarked = localStorage.getItem(`bookmark_${id}`);
    setIsBookmarked(!!isCoinBookmarked);
  }, [id]);

  const handleBookmark = () => {
    // Add the coin to bookmarks
    localStorage.setItem(`bookmark_${id}`, JSON.stringify(coin));
    setIsBookmarked(true);
  };

  const handleUnbookmark = () => {
    // Remove the coin from bookmarks
    localStorage.removeItem(`bookmark_${id}`);
    setIsBookmarked(false);
  };

  return (
    <div className="flex flex-col justify-between transition-transform ease-in-out duration-500 transform shadow-2xl hover:ring-2 hover:ring-blue-500 w-64 h-72 cursor-pointer p-6 mb-8 bg-white text-slate-800">
      <div>
        <div className="flex items-center space-x-2 mb-2">
          <p className="text-2xl font-semibold">
            {name} ({symbol})
          </p>
          {isBookmarked ? (
            <FaBookmark
              className="text-blue-500 cursor-pointer h-6 w-6"
              onClick={handleUnbookmark}
            />
          ) : (
            <FaRegBookmark
              className="text-blue-500 cursor-pointer h-6 w-6"
              onClick={handleBookmark}
            />
          )}
        </div>
        <div className="mb-4">{getStatusBadge(coin.is_active)}</div>
        <p className="text-gray-600 mb-2">Rank: {rank}</p>
        <p className="mb-4">
          <span className="text-gray-600">Price: </span>
          <span className="text-blue-500 font-bold">
            {coinPrice?.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 3,
              maximumFractionDigits: 3,
            })}
          </span>
        </p>
      </div>
      <Button to={`/CryptocurrenciesDetail/${coin.id}`} className="w-full">
        More <MdMoreHoriz className="text-white ml-2 inline" />
      </Button>
    </div>
  );
};

export default CoinCard;
